module.exports = __webpack_public_path__ + "assets/img/commission4.954c1228.svg";